export const CAMPAIGN_APPROVAL_STATUS_PENDING = 'pending';
export const CAMPAIGN_APPROVAL_STATUS_APPROVED = 'approved';
export const CAMPAIGN_APPROVAL_STATUS_REJECTED = 'rejected';
